import { atom } from "jotai";
import { RESET } from "jotai/utils";
import { emitEventOnWelcomeModalCloseSetter } from "@zapier/canvas-state";

import { showWelcomeModalAtom } from "./showWelcomeModalAtom";
import {
  isPromptToZslCompleteAtom,
  promptToZslErrorAtom,
} from "./streamingStatusAtoms";
import { aiPromptAtomResettable } from "./aiPromptAtom";

export const handleCloseModalSetter = atom(null, (_get, set) => {
  set(aiPromptAtomResettable, RESET); // When closing modal, we want the prompt to show up again even though we set it as empty in startOverSetter
  set(showWelcomeModalAtom, false);
  set(promptToZslErrorAtom, ""); // Clear out prompt => zsl error
  set(emitEventOnWelcomeModalCloseSetter);

  setTimeout(() => {
    /* setTimeout is so you don't see the button text change while modal is closing. */
    set(isPromptToZslCompleteAtom, null);
  }, 1000);
});

handleCloseModalSetter.debugLabel = "handleCloseModalSetter";
